import { Stack } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useActiveElements } from '../../../hooks/useActiveElements'
import { setIsbyCost, setQuantityLiters, setService } from '../../../slices/orderSlice'
import { MainButton } from '../../helpers'

const by = [
  {
    id: 'Por costo',
  },
  {
    id: 'Por litro',
  },
]
export const ByCostOrLiters = () => {
  const { data } = useSelector(state => state.products)
  const { activeData, handleActive } = useActiveElements(by)
  const dispatch = useDispatch()

  const handleIsbyCost = (id) => {
    id === 'Por costo' ? dispatch(setIsbyCost(true)) : dispatch(setIsbyCost(false))
    handleActive(id)
  }

  useEffect(() => {
    data.length > 0 && dispatch(setService(data[0]))
  }, [data])

  useEffect(() => {
    // dispatch(setQuantityLiters())
  }, [dispatch])
  return (
    <Stack direction="row" fullWidth spacing={1}>
      {
        activeData.map(item => (
          <MainButton key={item.id} variant={ item.active ? 'contained' : '' } text={`${item.id}`} sharp size="50%" height={40} onClick={() => handleIsbyCost(item.id)}/>
        ))
      }
    </Stack>
  )
}
